// Theme

const theme = {
  font: {
    primary: `'Raleway', sans-serif`,
    secondary: `'Raleway', sans-serif`,
    light: `'Raleway', sans-serif`,
    normal: `'Raleway', sans-serif`,
    medium: `'Raleway', sans-serif`,
    semibold: `'Raleway', sans-serif`,
    bold: `'Raleway', sans-serif`,
    extrabold: `'Raleway', sans-serif`,
  },
  font_size: {
    xxxsmall: "font-size: 12px;",
    xxsmall: "font-size: 14px;",
    xsmall: "font-size: 16px;",
    small: "font-size: 17px;",
    regular: "font-size: 22px; line-height: 30px;",
    large: "font-size: 28px; line-height: 30px;",
    larger: "font-size: 40px; line-height: 50px;",
    xlarge: "font-size: 48px; line-height: 48px;",
  },

  color: {
    primary: "#8d8d8d",
    secondary: "#098c8c",
    accent: "#cca86e",
    background: {
      white: "#ffffff",
      light: "#f8f8f8",
    },
    white: {
      regular: "#ffffff",
      lessdark: "#faf9f8",
      dark: "#f6f6f6",
      darker: "#eeeeee",
    },
    black: {
      lightest: "#ABA8AF",
      light: "#564F62",
      regular: "#000000",
    },
  },
  screen: {
    xs: "575px",
    sm: "767px",
    md: "991px",
    lg: "1199px",
  },
}

export default theme
